/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  const tluxyApplyCartCount = (count) => {
    document.querySelectorAll('[data-tluxy-cart-count]').forEach((badge) => {
      const qty = Number(count) || 0;
      badge.textContent = qty;
      badge.classList.toggle('is-hidden', qty < 1);
      badge.hidden = qty < 1;
    });
  };

  const tluxyFetchCartCount = async () => {
    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return;
      const cart = await response.json();
      tluxyApplyCartCount(cart.item_count || 0);
    } catch (error) {
      // fail silently
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tluxyFetchCartCount, { once: true });
  } else {
    tluxyFetchCartCount();
  }

  document.addEventListener('theme:cart:loaded', tluxyFetchCartCount);
  document.addEventListener('theme:cart:refresh', tluxyFetchCartCount);

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-add-to-cart], [data-item-remove], [data-quantity-plus], [data-quantity-minus], [name="checkout"]')) {
      window.setTimeout(tluxyFetchCartCount, 500);
      window.setTimeout(tluxyFetchCartCount, 1200);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-quantity-field], [data-quantity-select], .filter__input')) {
      window.setTimeout(tluxyFetchCartCount, 500);
    }
  });


  // T.LUXY V25.4 / V25.17: product descriptions carry warehouse data (barcode, internal/product code, gender) that customers should not see.
  const tluxyHideInternalSpecs = () => {
    if (!document.body.classList.contains('template-product')) return;
    const internal = /^\s*(codice a barre|barcode|codice prodotto|product code|codice interno|internal code|codice|code|genere|gender)\s*:/i;
    document.querySelectorAll('.product__accordion__inner li, .product__accordion__inner p, .product-description li').forEach((el) => {
      if (internal.test(el.textContent)) el.style.display = 'none';
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tluxyHideInternalSpecs, { once: true });
  } else {
    tluxyHideInternalSpecs();
  }
  document.addEventListener('theme:variant:change', () => window.setTimeout(tluxyHideInternalSpecs, 300));


  // T.LUXY V25.9: home banners — the whole picture opens the collection, not only the "Scopri" link.
  const tluxyClickableBanners = () => {
    document.querySelectorAll('.brick-block--image').forEach((block) => {
      if (block.querySelector('.featured-image__link, .tlx-img-link')) return;
      const btn = block.querySelector('a.btn[href]');
      const fig = block.querySelector('.featured-image__bg');
      if (!btn || !fig) return;
      const a = document.createElement('a');
      a.className = 'tlx-img-link';
      a.href = btn.getAttribute('href');
      a.tabIndex = -1;
      a.setAttribute('aria-hidden', 'true');
      a.style.cssText = 'position:absolute;inset:0;z-index:2;display:block;';
      if (getComputedStyle(fig).position === 'static') fig.style.position = 'relative';
      fig.appendChild(a);
      const h = block.querySelector('.featured-image__heading');
      if (h) { h.style.cursor = 'pointer'; h.addEventListener('click', () => { window.location.href = a.href; }); }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tluxyClickableBanners, { once: true });
  } else {
    tluxyClickableBanners();
  }


  // T.LUXY V25.10: search bar — solid white field under the menu, no category list, suggestions only while typing.
  // T.LUXY V25.11: product cards — name, price and extra price sit close together.
  // T.LUXY V25.12: Perfect Imperfection label on photos + dark, visible arrows in the zoomed gallery.
  // T.LUXY V25.14: on the product page the Perfect Imperfection label sits above the brand name.
  // T.LUXY V25.15: discount percentage next to the crossed-out price on the product page.
  // T.LUXY V25.16: WhatsApp (TextYess) "ask about it" button under Add to cart.
  // T.LUXY V25.18: language switch (Italiano · English) at the bottom of the mobile menu.
  // T.LUXY V25.20: "Designers" in capitals in the mobile menu, like the other items.
  const tlxArrow = (d) => 'url(data:image/svg+xml,%3Csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20viewBox=%270%200%2024%2024%27%20fill=%27none%27%20stroke=%27white%27%20stroke-width=%271.8%27%20stroke-linecap=%27round%27%20stroke-linejoin=%27round%27%3E%3Cpath%20d=%27' + d + '%27/%3E%3C/svg%3E)';
  const tlxSearchStyle = document.createElement('style');
  tlxSearchStyle.textContent = [
    '.search-popdown__body{background:#fff !important;border-bottom:1px solid #E6E1D8;}',
    '.search-popdown__main{background:#fff;}',
    '.search-popdown .popular-searches{display:none !important;}',
    '.search-popdown__results{background:#fff;}',
    '.search-popdown__results:not(:has(.predictive-search__item)){display:none !important;}',
    '.search-popdown .search-form__input{font-family:"Jost",sans-serif;font-size:15px;letter-spacing:.02em;color:#111;}',
    '.search-popdown .search-form__input::placeholder{color:#8a8580;opacity:1;}',
    '.product-grid-item__title{height:auto !important;}',
    '.product-grid-item__info{row-gap:4px !important;padding-top:8px !important;}',
    '.product-grid-item__info-content{row-gap:4px !important;}',
    '.tluxy-checkout-note--line{margin-top:2px !important;}',
    '.pswp__button--arrow--left,.pswp__button--arrow--right{width:44px !important;height:44px !important;margin-top:-22px !important;border-radius:50% !important;opacity:1 !important;box-shadow:0 4px 14px rgba(0,0,0,.18) !important;background-color:#111 !important;background-position:center !important;background-size:18px 18px !important;background-repeat:no-repeat !important;}',
    '.pswp__button--arrow--right{background-image:' + tlxArrow('M5%2012h14M13%206l6%206-6%206') + ' !important;right:12px !important;}',
    '.pswp__button--arrow--left{background-image:' + tlxArrow('M19%2012H5M11%206l-6%206%206%206') + ' !important;left:12px !important;}',
    '.pswp__button--arrow--left:before,.pswp__button--arrow--right:before{display:none !important;}',
    '.tlx-pi-badge{position:absolute;top:10px;left:10px;z-index:3;display:inline-flex;align-items:center;gap:6px;padding:5px 9px 5px 8px;background:rgba(255,255,255,.92);border:1px solid #D9D2C5;border-radius:2px;font-family:"Jost",sans-serif;font-size:9.5px;font-weight:500;letter-spacing:.14em;text-transform:uppercase;color:#111;line-height:1;pointer-events:none;white-space:nowrap;}',
    '.tlx-pi-badge:before{content:"";width:6px;height:6px;border-radius:50%;background:#B8860B;flex:none;}',
    '[data-tlx-pi-pdp]{display:none !important;}',
    '.tlx-pi-pdp-row{display:block;margin:0 0 12px;}',
    '.tlx-pi-pdp-row > [data-tlx-pi-pdp]{display:inline-flex !important;position:static;font-size:10.5px;padding:7px 11px 7px 10px;gap:7px;background:#fff;}',
    '.product__price .tlx-off{color:#8a1c1c;font-weight:500;font-size:.8em;margin-left:8px;white-space:nowrap;}',
    '[data-tlx-wa]{display:none !important;}',
    '.tlx-wa-row{margin:12px 0 4px;}',
    '.tlx-wa-row > [data-tlx-wa]{display:flex !important;align-items:center;justify-content:center;gap:10px;width:100%;min-height:48px;padding:12px 16px;box-sizing:border-box;background:#fff;border:1px solid #111;color:#111;font-family:"Jost",sans-serif;font-size:12px;font-weight:500;letter-spacing:.12em;text-transform:uppercase;text-decoration:none;transition:background .2s,color .2s;}',
    '.tlx-wa-row > [data-tlx-wa]:hover{background:#111;color:#fff;}',
    '.tlx-wa-row > [data-tlx-wa] svg{flex:none;}',
    '.tlx-mlang{display:flex !important;align-items:center;gap:10px;margin:22px 20px 0;padding-top:18px;border-top:1px solid #E6E1D8;list-style:none;font-family:"Jost",sans-serif;font-size:14px;}',
    '.tlx-mlang__label{font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:#8a8580;margin-right:6px;}',
    '.tlx-mlang a{color:#8a8580;text-decoration:none;}',
    '.tlx-mlang a.is-active{color:#111;font-weight:500;text-decoration:underline;text-underline-offset:4px;}',
    '.tlx-mlang__sep{color:#C9C2B6;}',
    'body:has(#nav-drawer-header.is-open) #TlxClubTab{display:none !important;}',
    '#nav-drawer-header a[href$="/pages/designers"]{text-transform:uppercase;}',
    '@media (max-width:767px){.tlx-pi-badge{top:6px;left:6px;font-size:8px;padding:4px 6px;gap:4px;letter-spacing:.1em;}.tlx-pi-badge:before{width:5px;height:5px;}.tlx-pi-pdp-row{margin:4px 0 10px;}.tlx-pi-pdp-row > [data-tlx-pi-pdp]{font-size:9.5px;padding:6px 9px;gap:6px;}}'
  ].join('');
  document.head.appendChild(tlxSearchStyle);

  const tlxMobileLang = () => {
    const drawer = document.querySelector('#nav-drawer-header');
    if (!drawer || drawer.querySelector('.tlx-mlang')) return;
    const search = drawer.querySelector('[data-nav-search-open]');
    const anchorEl = search ? (search.closest('li') || search) : null;
    const list = anchorEl ? anchorEl.parentElement : null;
    if (!list) return;
    const isIt = ((window.Shopify && Shopify.locale) || document.documentElement.lang || '').toLowerCase().startsWith('it');
    const path = window.location.pathname.replace(/^\/it(?=\/|$)/, '') || '/';
    const tail = window.location.search + window.location.hash;
    const itUrl = (path === '/' ? '/it' : '/it' + path) + tail;
    const enUrl = path + tail;
    const box = document.createElement('li');
    box.className = 'tlx-mlang';
    box.innerHTML = '<span class="tlx-mlang__label">' + (isIt ? 'Lingua' : 'Language') + '</span>' +
      '<a href="' + itUrl + '" hreflang="it" lang="it"' + (isIt ? ' class="is-active" aria-current="true"' : '') + '>Italiano</a>' +
      '<span class="tlx-mlang__sep">·</span>' +
      '<a href="' + enUrl + '" hreflang="en" lang="en"' + (!isIt ? ' class="is-active" aria-current="true"' : '') + '>English</a>';
    list.appendChild(box);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tlxMobileLang, { once: true });
  } else {
    tlxMobileLang();
  }

  const tlxPdpBadge = () => {
    const badge = document.querySelector('[data-tlx-pi-pdp]');
    const title = document.querySelector('.product__block--title');
    if (badge && title && !badge.closest('.tlx-pi-pdp-row')) {
      const row = document.createElement('div');
      row.className = 'tlx-pi-pdp-row';
      row.appendChild(badge);
      title.parentElement.insertBefore(row, title);
    }
    const wa = document.querySelector('[data-tlx-wa]');
    const holder = document.querySelector('.product-single__details .product__submit__holder');
    if (wa && holder && !wa.closest('.tlx-wa-row')) {
      const waRow = document.createElement('div');
      waRow.className = 'tlx-wa-row';
      waRow.appendChild(wa);
      holder.insertAdjacentElement('afterend', waRow);
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tlxPdpBadge, { once: true });
  } else {
    tlxPdpBadge();
  }
  window.addEventListener('load', tlxPdpBadge);

  const tlxMoney = (t) => {
    const s = (t || '').replace(/[^\d.,]/g, '');
    if (!s) return NaN;
    return parseFloat(s.replace(/\./g, '').replace(',', '.'));
  };
  const tlxPdpPercent = () => {
    document.querySelectorAll('.product__price[data-price-wrapper]').forEach((wrap) => {
      const priceEl = wrap.querySelector('[data-product-price]');
      const compareEl = wrap.querySelector('[data-compare-price]');
      let off = wrap.querySelector('.tlx-off');
      const price = tlxMoney(priceEl && priceEl.textContent);
      const compare = tlxMoney(compareEl && compareEl.textContent);
      const visible = compareEl && compareEl.offsetParent !== null && compare > price;
      const pct = visible ? Math.floor((compare - price) / compare * 100) : 0;
      if (pct < 1) { if (off) off.remove(); return; }
      if (!off) {
        off = document.createElement('span');
        off.className = 'tlx-off';
        compareEl.insertAdjacentElement('afterend', off);
      }
      const label = '−' + pct + '%';
      if (off.textContent !== label) off.textContent = label;
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tlxPdpPercent, { once: true });
  } else {
    tlxPdpPercent();
  }
  window.addEventListener('load', tlxPdpPercent);
  document.addEventListener('theme:variant:change', () => window.setTimeout(tlxPdpPercent, 150));
  document.addEventListener('change', (event) => {
    if (event.target.closest('.product-single__details, product-form, variant-selects')) window.setTimeout(tlxPdpPercent, 250);
  });

  const tlxSearchPlaceholder = (document.documentElement.lang || '').toLowerCase().startsWith('it')
    ? 'Cerca designer, borse, scarpe…'
    : 'Search designers, bags, shoes…';
  const tlxPlaceSearch = () => {
    document.querySelectorAll('.search-popdown details[open] .search-popdown__body').forEach((body) => {
      const header = body.closest('header-component, .site-header');
      if (header) body.style.top = Math.round(header.getBoundingClientRect().bottom) + 'px';
      const input = body.querySelector('.search-form__input');
      if (input && !input.placeholder) input.placeholder = tlxSearchPlaceholder;
    });
  };
  document.addEventListener('toggle', (event) => {
    if (event.target.closest && event.target.closest('.search-popdown')) requestAnimationFrame(tlxPlaceSearch);
  }, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-popdown-toggle]')) window.setTimeout(tlxPlaceSearch, 60);
  });
  window.addEventListener('resize', tlxPlaceSearch);


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();